import { toZonedTime } from 'date-fns-tz';
const PARIS_TZ = 'Europe/Paris';
/**
 * Heure limite de paiement le jour de l'échéance : 17h00 en semaine, 12h00 le
 * week-end. Une seule règle pour l'espace client, le contrat de réservation, le
 * mail « Reprise de versement » et les SMS, pour que le client lise partout la
 * même heure.
 *
 * Le jour est lu à Paris : les échéances sont stockées à minuit UTC, donc un
 * fuseau à l'ouest de Greenwich les ferait glisser à la veille.
 */
export function paymentDeadlineTime(deadline) {
    const day = toZonedTime(deadline, PARIS_TZ).getDay(); // 0 = dimanche, 6 = samedi
    return day === 0 || day === 6 ? '12h00' : '17h00';
}
